import { createContext } from 'react';
export var defaultClassNames = {};
export default createContext({});